import useWorkspace from 'store/redux/hooks/useWorkspace';

export default function useWorkspaceBilling() {
  const { workspace, isLoading, isError } = useWorkspace();

  const plan = workspace?.plan;

  const hasActivePlan = () => {
    return plan?.active === true;
  };

  const hasFreePlan = () => {
    return plan?.free_trial === true || plan?.is_free === true;
  };

  const getFreeDaysLeft = () => {
    return plan?.free_days_left;
  };

  return {
    hasPlan: Boolean(plan) && plan?.is_active,
    hasFreeTrial: plan?.code === 'free_trial',
    validUntil: plan?.valid_until,
    currentGmv: workspace.current_gmv,
    predictedGmv: workspace.predicted_gmv,
    isLoading: isLoading || !workspace?.id,
    plan_code: plan?.code,
    provider: plan?.provider,

    period: {
      period: plan?.period,
      period_name:
        plan?.period === 'yearly' ? 'Yearly' : plan?.period === 'monthly' ? 'Monthly' : 'Lifetime',
      per_period_name:
        plan?.period === 'yearly'
          ? 'Per Year'
          : plan?.period === 'monthly'
          ? 'Per Month'
          : 'Lifetime',
      isYearly: plan?.period === 'yearly',
      isMonthly: plan?.period === 'monthly',
      isLifetime: plan?.period === 'lifetime',
    },
    nextChargeDate: plan?.next_charge_date,
    nextBillPrice: plan?.next_bill_price,
    is_active: Boolean(plan?.is_active),
    isError,
    hasFreePlan,
    hasActivePlan,
    getFreeDaysLeft,
  };
}
